import React, { useState } from "react";
import Icon from "components/Icon";
import "./styles/main.css";
import Cookies from 'js-cookie';

const OptionsBtn = ({
	className,
	iconId,
	iconClassName,
	ariaLabel,
	options = [],
	position = "left",
	showPressed = true,
	...props
}) => {
	const [showOptions, setShowOptions] = useState(false);

	const handleOptionClick = (option) => {
		// console.log('OPTION CLICKED', option)
		if(option === 'Log out'){
			// console.log('loggin out', option)
			// window.location.reload();
			Cookies.remove('_auth');

			window.location.replace("/");

		}
	  };

	return (
		<div className="pos-rel">
			<button
				aria-label={ariaLabel}
				className={`options-btn ${
					showOptions && showPressed ? "options-btn--pressed" : ""
				} ${className || ""}`}
				onClick={() => setShowOptions(!showOptions)}
				{...props}
			>
				<Icon id={iconId} className={iconClassName} />
			</button>
			<ul
				className={`options-btn__options ${
					showOptions ? "options-btn__options--active" : ""
				} ${position === "right" ? "options-btn__options--right" : ""}`}
			>
				{options.map((option, index) => (
					<li className="options-btn__option" key={index} onClick={() => handleOptionClick(option)}>
						{option}
					</li>
				))}
			</ul>
		</div>
	);
};

export default OptionsBtn;
